<template>
  <div class="invite-friends">
    <pageHeader title="邀请好友送礼" />

    <div class="invite-title-bg">
      <img src="@/assets/images/invite-bg.png" alt="" />
      <div @click="activeRuleDialogVisible = true" class="active-rule">活动规则</div>
    </div>

    <div class="container">
      <div class="invite-notice">
        <ul class="notice-box">
          <li class="notice-item" v-for="(item, i) in dataList" :key="i">
            <img src="@/assets/images/invite-notice.png" alt="" /><span
              >用户{{ item.phone }}</span
            ><span
              >已领 满{{ item.enableAmount }}减{{ item.amount }} 优惠券</span
            >
          </li>
        </ul>
      </div>

      <div class="invite-btn" @click="showShare = true">立即邀请好友</div>

      <div class="statistics">
        <div class="statist-card">
          <div class="number">
            <span>{{ totalMoney }}</span
            ><span>元</span>
          </div>
          <span class="desc">累计获取优惠券</span>
          <div class="record" @click="collectionRouter">
            <span>领取记录</span>
            <img src="@/assets/images/arrow-right.png" alt="" />
          </div>
        </div>
        <div class="statist-card">
          <div class="number">
            <span>{{ inviteNum }}</span
            ><span>人</span>
          </div>
          <span class="desc">累计邀请人数</span>
          <div class="record" @click="inviteRouter">
            <span>邀请记录</span>
            <img src="@/assets/images/arrow-right.png" alt="" />
          </div>
        </div>
      </div>

      <div class="btm-tip">— 万梦手游 —</div>

      <van-share-sheet
        v-model="showShare"
        :options="options"
        @select="onSelect"
      />
    </div>

    <activeRuleDialog 
      v-if="activeRuleDialogVisible"
      v-model="activeRuleDialogVisible"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import activeRuleDialog from "@/components/ActiveRuleDialog"
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import copy from 'copy-to-clipboard';
export default {
  components: {
    pageHeader,
    activeRuleDialog
  },
  data() {
    return {
      showShare: false,
      options: [
        // { name: '微信好友', icon: 'wechat' },
        // { name: '朋友圈', icon: 'wechat-moments' },
        // { name: 'QQ', icon: 'qq' },
        { name: "复制链接", icon: "link" },
      ],
      dataList: [],
      totalMoney: 0,
      inviteNum: 0,
      activeIndex: 0,
      intnum: null,
      activeRuleDialogVisible: false
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  async mounted() {
    await this.fetchInviteUserList();
    this.fetchInviteUserInfo();
  },
  methods: {
    /**
     * 获取邀请记录
     */
    async fetchInviteUserList() {
      try {
        const { data } = await requestMethods(
          "/modules/coupon/userCoupon/getAllUserCouponList.htm",
          "post",
          {
            appType: "WM",
            currentPage: 1,
            pageSize: 50,
          }
        );
        this.dataList = data || [];
      } catch (err) {
        this.$toast(err.message);
      }
    },

    /**
     * 获取邀请数据
     */
    async fetchInviteUserInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/user/user/fetchInviteInfo.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        const { totalMoney, inviteUserList } = data;
        this.totalMoney = totalMoney;
        this.inviteNum = inviteUserList.length;
      } catch (err) {
        this.$toast(err.message);
      }
    },

    /**
     * 跳转到邀请记录
     */
    inviteRouter() {
      this.$router.push({ path: "/inviteRecord" });
    },

    /**
     * 跳转到领取记录
     */
    collectionRouter() {
      this.$router.push({ path: "/collectionRecord" });
    },

    onSelect(e) {
      console.log(e);
      if (e.icon == "link") {
        copy(`https://wmsy666.com/invite/?uuid=${this.uuid}`)
        this.$toast("链接已复制到剪切板！");
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-friends {
  .invite-title-bg {
    position: relative;
    img {
      width: 100%;
      height: 760px;
      vertical-align: bottom;
    }

    .active-rule {
      position: absolute;
      top: 39px;
      right: 0;
      width: 150px;
      height: 50px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 100px 0px 0px 100px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
    }
  }
  .container {
    background: #f3d5af;

    .invite-notice {
      margin: 0 30px;
      width: 690px;
      height: 230px;
      background: #fff6f1;
      box-shadow: 0px 0px 30px 0px rgba(188, 150, 135, 0.3);
      border-radius: 16px;
      padding: 30px 0;
      overflow: hidden;
      position: relative;

      .notice-box {
        // position: relative;
        // z-index: 2;
        // float: left;
        // margin-left: 5%;
        // overflow: hidden;
        margin-left: 64px;
        // height: 100%;
        list-style: none;
        animation: scroll 100s linear infinite; /* 动画设置 */
        // overflow: hidden;
        // text-overflow: ellipsis;
        // // /* -webkit-line-clamp: 5; */
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        .notice-item {
          display: flex;
          align-items: center;
          margin-bottom: 23px;

          // -webkit-animation: 3s anim2 linear infinite normal;
          // animation: 3s anim2 linear infinite normal;

          &:last-child {
            margin-bottom: 0;
          }
          img {
            width: 22px;
            height: 20px;
            margin-right: 8px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #666666;
            line-height: 37px;

            &:last-child {
              margin-left: 88px;
            }
          }
        }

        // .notice-item:hover {
        //   /* 设置动画是否暂停 paused暂停*/
        //   animation: 10s anim2 linear infinite paused;
        // }
      }
    }

    .invite-btn {
      width: 500px;
      height: 80px;
      background: url("~@/assets/images/invite-btn.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 80px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;

      margin: 0 auto;
      margin-top: 40px;
    }

    .statistics {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      margin-top: 40px;

      .statist-card {
        width: 340px;
        height: 210px;
        padding: 30px 0 20px 0;
        background: #fff6f1;
        box-shadow: 0px 0px 30px 0px rgba(188, 150, 135, 0.3);
        border-radius: 16px;
        text-align: center;

        .number {
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 28px;
            color: #212121;
            line-height: 62px;

            &:first-child {
              font-size: 44px;
              font-weight: 500;
              margin-right: 8px;
            }
          }
        }
        .desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #666666;
          line-height: 40px;
        }
        .record {
          margin-top: 25px;
          margin-left: 110px;
          // height: 33px;
          // line-height: 33px;
          display: flex;
          align-items: center;
          img {
            width: 14px;
            height: 26px;
            margin-left: 10px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 24px;
            color: #bbbbbb;
            line-height: 33px;
          }
        }
      }
    }

    .btm-tip {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #7f3300;
      line-height: 28px;
      padding: 19px 0 14px 0;
      text-align: center;
    }
  }
}

@keyframes scroll {
  0% {
    transform: translateY(0); /* 初始位置 */
  }
  100% {
    transform: translateY(-100%); /* 向上滚动到列表的最后 */
  }
}
// @-webkit-keyframes anim2 {
//   0% {
//     -webkit-transform: translate3d(0, 0, 0);
//     transform: translate3d(0, 0, 0);
//   }
//   100% {
//     -webkit-transform: translate3d(0, 120px, 0);
//     transform: translate3d(0, -120px, 0);
//   }
// }
// @keyframes anim2 {
//   0% {
//     -webkit-transform: translate3d(0, 0, 0);
//     transform: translate3d(0, 0, 0);
//   }

//   100% {
//     -webkit-transform: translate3d(0, -120px, 0);
//     transform: translate3d(0, -120px, 0);
//   }
// }
</style>


// WEBPACK FOOTER //
// src/views/inviteFriends/index.vue